module.exports = __webpack_public_path__ + "img/scalemailsabatons.ed87de30.png";